import React,{Component} from 'react';
import {ArticleCard} from './ArticleCard';
import {ImgCard} from './ImgCard';
import {PackageCard} from './PackageCard';
import {CardPackage} from './CardPackage';
import {ProgramPlusCard, ProgramPlusCardStyles} from './ProgramPlusCard';
import { Link } from "react-router-dom";
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import {Swiper,SwiperSlide,EffectFade} from 'swiper/react';
import SwiperCore,{Autoplay} from 'swiper/core';
import { Pagination, Navigation } from "swiper";
import Clock from 'react-clock';
import moment from '../img/impressive_moment_icon.svg'
import 'react-clock/dist/Clock.css';
import 'swiper/swiper.scss';
SwiperCore.use([Autoplay]);

export class Home extends Component {
  static displayName = Home.name;

  constructor(props) {
    super(props);
    this.state = {forecasts: [],loading: true,aloading:true,eloading:true,Time: new Date(),windowWidth: window.innerWidth,
            tourlist: [{},{},{}],
            asianlist:[{},{},{}],
            eurolist:[{},{},{}],
            programPlusList: [], ppLoading: true,
            slides: [],
            moments: [],
            momentViewerIndex: -1,
            setting: {}};
    this.handleResize = this.handleResize.bind(this);
    this.setZoneTime = this.setZoneTime.bind(this);
  }

  componentDidMount() {
    this.populateWeatherData();
    setInterval(() => this.setState({Time: new Date()}),1000);
    window.addEventListener("resize",this.handleResize);

    this.GetDataList('','','3','');
    this.GetDataList('','','2','');
    this.GetDataList('','','1','');
    this.GetProgramPlus();
    this.GetSlides();
    this.GetMoments();
    this.GetSetting();
  }

  GetSlides() {
    fetch('api/homeslide')
      .then(r => r.ok ? r.json() : [])
      .then(slides => this.setState({ slides }))
      .catch(() => {});
  }

  GetMoments() {
    fetch('api/moment')
      .then(r => r.ok ? r.json() : [])
      .then(moments => this.setState({ moments }))
      .catch(() => {});
  }

  GetSetting() {
    fetch('api/sitesetting')
      .then(r => r.ok ? r.json() : {})
      .then(setting => this.setState({ setting: setting || {} }))
      .catch(() => {});
  }

  filterByHashtag(tag) {
    var t = (tag || '').toLowerCase().replace(/^#/, '');
    return (this.state.programPlusList || []).filter(p => (p.hashtags || []).some(h => (h || '').toLowerCase().replace(/^#/, '') === t));
  }

  renderTagSwiper(list) {
    var w = this.state.windowWidth;
    var perView = w < 700 ? 1 : w < 1000 ? 2 : w < 1400 ? 3 : 3;
    if (!list || list.length === 0) {
      return <div className="text-center py-4" style={{ color: '#bbb' }}>ยังไม่มีโปรแกรมในหมวดนี้</div>;
    }
    return (
      <Swiper modules={Navigation} spaceBetween={12} slidesPerView={perView} loop={list.length > perView}
        autoplay={{ delay: 6000, disableOnInteraction: false }}>
        {list.map(p => (
          <SwiperSlide key={p.id}>
            <div style={{ padding: 4 }}>
              <ProgramPlusCard p={p} linkTo={'/programplus/view/' + p.id} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }

  GetProgramPlus() {
    fetch('api/programplus')
      .then(r => r.ok ? r.json() : [])
      .then(json => this.setState({ programPlusList: json, ppLoading: false }))
      .catch(() => this.setState({ ppLoading: false }));
  }

  componentWillUnmount() {
    window.addEventListener("resize",this.handleResize);
  }

  handleResize = (e) => {
    this.setState({windowWidth: window.innerWidth});
  };
  async populateWeatherData() {
    const response = await fetch('api/article');
    const data = await response.json();
    this.setState({forecasts: data,loading: false});
  }
  setZoneTime = (h) => {

    let dd = new Date();
    dd.setTime(dd.getTime() + h * 60 * 60 * 1000);
    return dd;
  }
  GetDataList(code,name,country_id,province_id) {
    this.setState({loading: true});
    this.setState({aloading: true});
    this.setState({eloading: true});
    fetch(`api/ProgramList?country_id=${country_id}&province_id=${province_id}&code=${code}&name=${name}`,{
        method: 'get',
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    })
        .then(function (response) {
            if (response.ok) {
                response.json().then(function (json) {
                    if(country_id=='3') { this.setState({tourlist: json,loading: false,PageState: "L"});}
                    else if(country_id=='2'){this.setState({asianlist: json,aloading: false,PageState: "L"});}
                    else if(country_id=='1'){this.setState({eurolist: json,eloading: false,PageState: "L"});}
                }.bind(this))
            }

            else {
                response.text().then(function (text) {

                });
            }
        }.bind(this))
        .catch(function (error) {
        });
}
  static renderForecastsTable(forecasts) {
    var HtmlToReactParser = require('html-to-react').Parser;

    var htmlInput = '<div><h1>Title</h1><p>A paragraph</p></div>';
    var htmlToReactParser = new HtmlToReactParser();
    var reactElement = htmlToReactParser.parse(htmlInput);
    return (
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>id</th>
            <th>Name</th>
            <th>Capture</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          {forecasts.map(forecast =>
            <tr key={forecast.ART_ID}>
              <td>{forecast.arT_ID}</td>
              <td>{forecast.arT_NAME}</td>
              <td>{forecast.arT_CAPTION}</td>
              <td>{htmlToReactParser.parse(forecast.arT_DETAIL)}</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    // let contents = this.state.loading
    // ? <p><em>Loading...</em></p>
    // : Home.renderForecastsTable(this.state.forecasts);

    const {tourlist,asianlist,eurolist,loading,aloading,eloading,programPlusList,ppLoading,slides,moments,momentViewerIndex,setting} = this.state;
    const openMoment = (i) => this.setState({ momentViewerIndex: i });
    const closeMoment = () => this.setState({ momentViewerIndex: -1 });
    const nextMoment = () => this.setState({ momentViewerIndex: (momentViewerIndex + 1) % moments.length });
    const prevMoment = () => this.setState({ momentViewerIndex: (momentViewerIndex - 1 + moments.length) % moments.length });
    return (
      <div className="container_home">
        <ProgramPlusCardStyles />
        {//contents
        }

        <div className="home-hero-wrap">
          <style>{`
            .home-hero-wrap { position:relative; margin-bottom: 40px; }
            .home-hero-wrap .swiper-container, .home-hero-wrap .swiper { overflow:hidden; }
            .home-hero-slide { position:relative; width:100%; height: 70vh; max-height: 640px; min-height: 380px; overflow:hidden; background:#000; }
            @media (max-width: 768px) { .home-hero-slide { height: 50vh; min-height: 280px; } }
            .home-hero-slide img { width:100%; height:100%; object-fit:cover; display:block; transform: scale(1.05); transition: transform 6s ease-out; }
            .home-hero-wrap .swiper-slide-active .home-hero-slide img { transform: scale(1); }
            .home-hero-overlay { position:absolute; inset:0; background: linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0) 40%, rgba(0,0,0,0.55) 100%); display:flex; align-items:flex-end; padding: 0 8% 80px; color:#fff; }
            .home-hero-content { max-width: 700px; transform: translateY(30px); opacity:0; transition: all 0.8s ease 0.2s; }
            .home-hero-wrap .swiper-slide-active .home-hero-content { transform: translateY(0); opacity:1; }
            .home-hero-tag { display:inline-block; font-size:12px; letter-spacing:3px; font-weight:700; padding:5px 14px; background:#dc3545; border-radius:20px; margin-bottom:14px; text-transform:uppercase; }
            .home-hero-title { font-size: 44px; font-weight: 900; line-height:1.15; margin:0 0 10px; text-shadow: 0 2px 12px rgba(0,0,0,0.3); }
            @media (max-width: 768px) { .home-hero-title { font-size: 28px; } }
            .home-hero-desc { font-size: 17px; line-height:1.5; margin-bottom: 20px; text-shadow: 0 1px 6px rgba(0,0,0,0.3); opacity:0.95; }
            @media (max-width: 768px) { .home-hero-desc { font-size: 14px; } }
            .home-hero-cta { display:inline-flex; align-items:center; gap:8px; background:#fff; color:#c82333; padding:12px 26px; border-radius:30px; font-size:14px; font-weight:700; text-decoration:none !important; transition: all 0.2s; box-shadow: 0 4px 18px rgba(0,0,0,0.2); }
            .home-hero-cta:hover { background:#c82333; color:#fff; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0,0,0,0.3); }

            .home-hero-wrap .swiper-button-next, .home-hero-wrap .swiper-button-prev { width:52px; height:52px; background: rgba(255,255,255,0.9); border-radius:50%; color:#c82333; opacity:0; transition: all 0.3s; box-shadow: 0 4px 14px rgba(0,0,0,0.2); margin-top: -26px; }
            .home-hero-wrap:hover .swiper-button-next, .home-hero-wrap:hover .swiper-button-prev { opacity:1; }
            .home-hero-wrap .swiper-button-next:hover, .home-hero-wrap .swiper-button-prev:hover { background:#c82333; color:#fff; }
            .home-hero-wrap .swiper-button-next::after, .home-hero-wrap .swiper-button-prev::after { font-size:18px; font-weight: 900; }
            .home-hero-wrap .swiper-button-prev { left: 28px; }
            .home-hero-wrap .swiper-button-next { right: 28px; }

            .home-hero-wrap .swiper-pagination { bottom: 28px !important; }
            .home-hero-wrap .swiper-pagination-bullet { width:10px; height:10px; background:#fff; opacity:0.6; transition: all 0.3s; }
            .home-hero-wrap .swiper-pagination-bullet-active { opacity:1; width:32px; border-radius:5px; background:#dc3545; }
          `}</style>
          <Swiper
            modules={[Pagination, Navigation]}
            navigation={true}
            pagination={{ clickable: true, dynamicBullets: false }}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 6000, disableOnInteraction: false }}>
            {(slides && slides.length > 0 ? slides : [
              { id:'d1', image:'/images/Adv01.png', title:'', url:'' },
              { id:'d2', image:'/images/Adv02.png', title:'', url:'' },
              { id:'d3', image:'/images/Adv03.png', title:'', url:'' }
            ]).map(s => {
              var inner = (
                <div className="home-hero-slide">
                  <img src={s.image} alt={s.title||''} />
                  <div className="home-hero-overlay">
                    <div className="home-hero-content">
                      {s.title && <div className="home-hero-tag">New</div>}
                      {s.title && <h1 className="home-hero-title">{s.title}</h1>}
                      {s.desc && <div className="home-hero-desc">{s.desc}</div>}
                      {s.url && <span className="home-hero-cta">เรียนรู้เพิ่มเติม <i className="fas fa-arrow-right"></i></span>}
                    </div>
                  </div>
                </div>
              );
              return (
                <SwiperSlide key={s.id}>
                  {s.url ? (
                    <a href={s.url} target={s.url.startsWith('http') ? '_blank' : '_self'} rel="noopener noreferrer" style={{ display:'block', textDecoration:'none' }}>{inner}</a>
                  ) : inner}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        {/* Group Request CTA */}
        <div className="container mb-4 mt-3">
          <div style={{ background:'linear-gradient(135deg, #dc3545, #c02911)', borderRadius:12, padding:'20px 24px', color:'#fff', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
            <div>
              <div style={{ fontSize:20, fontWeight:800 }}><i className="fas fa-users"></i> จัดกรุ๊ปส่วนตัว</div>
              <div style={{ fontSize:13, opacity:0.9 }}>ออกแบบทริปตามความต้องการของคุณ ทีมงานจะติดต่อกลับโดยเร็ว</div>
            </div>
            <Link to="/group-request" className="btn btn-light" style={{ fontWeight:700, color:'#dc3545' }}>
              <i className="fas fa-paper-plane"></i> ขอจัดกรุ๊ป
            </Link>
          </div>
        </div>

        {/* ทัวร์แนะนำประเทศญี่ปุ่น (#JAPAN) */}
        <div className="container_home mb-5">
          <div className="home-package row m-0">
            <div className="tourTitle"><h1>ทัวร์แนะนำประเทศญี่ปุ่น </h1></div>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="panal-package-list col-12">
                  {this.renderTagSwiper(this.filterByHashtag('JAPAN'))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ทัวร์แนะนำโซนเอเชีย (#ASIAN) */}
        <div className="container_home mb-5">
          <div className="home-package row m-0">
            <div className="tourTitle"><h1>ทัวร์แนะนำโซนเอเชีย </h1></div>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="panal-package-list col-12">
                  {this.renderTagSwiper(this.filterByHashtag('ASIAN'))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ทัวร์แนะนำโซนยุโรป (#EURO) */}
        <div className="container_home mb-5">
          <div className="home-package row m-0">
            <div className="tourTitle"><h1>ทัวร์แนะนำโซนยุโรป </h1></div>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="panal-package-list col-12">
                  {this.renderTagSwiper(this.filterByHashtag('EURO'))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* โปรแกรมท่องเที่ยวของเรา (Program Plus all) */}
        {(ppLoading || programPlusList.length > 0) && (
          <div className="container_home mb-5">
            <div className="home-package row m-0">
              <div className="tourTitle">
                <h1>โปรแกรมท่องเที่ยวของเรา </h1>
              </div>
              <div className="container">
                <div className="row">
                  {ppLoading
                    ? [0,1,2].map(i => (
                        <div key={i} className="col-md-6 col-lg-4 mb-4">
                          <ProgramPlusCard loading={true} />
                        </div>
                      ))
                    : programPlusList.slice(0,6).map((p) => (
                        <div key={p.id} className="col-md-6 col-lg-4 mb-4">
                          <ProgramPlusCard p={p} linkTo={'/programplus/view/' + p.id} />
                        </div>
                      ))}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="container_home_3">

          <br />
          {/* <div className="container_home">
            <div className="time-panal row m-0">
              <div className="tourTitle">
                <h1>Time Zone </h1>
              </div>
              <br />
              <div className="panal-package-list row col-12">
                <div className="col-3 text-center time-box">
                  <div className='time-name'>JAPAN</div>
                  <Clock value={this.setZoneTime(2)} size={70} />
                  <div className='time-display'>{("0" + this.setZoneTime(2).getHours()).slice(-2)}:{("0" + this.state.Time.getMinutes()).slice(-2)}:{("0" + this.state.Time.getSeconds()).slice(-2)}</div>
                </div>
                <div className="col-3 text-center time-box">
                  <div className='time-name'>THAILAND</div>
                  <Clock value={this.state.Time} size={70} />
                  <div className='time-display'>{this.state.Time.getHours()}:{("0" + this.state.Time.getMinutes()).slice(-2)}:{("0" + this.state.Time.getSeconds()).slice(-2)}</div>
                </div>
                <div className="col-3 text-center time-box">
                  <div className='time-name'>UNITED STATE</div>
                  <Clock value={this.setZoneTime(-11)} size={70} />
                  <div className='time-display'>{("0" + this.setZoneTime(-11).getHours()).slice(-2)}:{("0" + this.state.Time.getMinutes()).slice(-2)}:{("0" + this.state.Time.getSeconds()).slice(-2)}</div>
                </div>
                <div className="col-3 text-center time-box">
                  <div className='time-name'>AUSTRALIA</div>
                  <Clock value={this.setZoneTime(3)} size={70} />
                  <div className='time-display'>{("0" + this.setZoneTime(3).getHours()).slice(-2)}:{("0" +this.state.Time.getMinutes() ).slice(-2)}:{("0" +this.state.Time.getSeconds() ).slice(-2)}</div>
                </div>
              </div>
              <br />
            </div>
          </div> */}
          <div className="home-package row m-0">
            <div className="tourTitle">
              <h1>พาคุณท่องเที่ยวตามฤดูกาล </h1>
            </div>
          </div>
          <div className="home-article_2 row m-0  justify-content-md-center">
            <div className="col-md-5 card-contenner">
              {<ImgCard id="1" />}
            </div>
            <div className="col-md-5 card-contenner">
              {<ImgCard id="2" />}
            </div>
            <div className="col-md-5 card-contenner">
              {<ImgCard id="3" />}
            </div>
            <div className="col-md-5 card-contenner">
              {<ImgCard id="4" />}
            </div>

          </div>
        </div>

        <div className="ad1">
          <img src={require('../img/stripbanner_ant_home_2.jpg')} ></img>
          <div className="adinfo">
            <div className="article-card-detail">
              Intensive Group ท่องเที่ยวในแบบที่คุณเลือกได้ <br /> จัดกรุ๊บเที่ยวส่วนตัว เอ้าท์ติ้งบริษัท ศีกษาดูงานครบจบในที่เดียว
            </div>
            <div className="article-card-read mt-2">
              <a href="/group-request">
                View more
              </a>
            </div>
          </div>
        </div>
        <div className="ad2">

          <img src={require('../img/stripbanner_ant_home_1.jpg')} ></img>
          <div className="adinfo">
            <div className="article-card-detail">
              ให้ท่องเที่ยวด้วยตัวเองเป็นเรื่องง่ายๆ<br />เลือกบริการต่างๆในแบบที่คุณเป็น
            </div>
            <div className="article-card-read mt-2">
              <a href="/programs/search">
                View more
              </a>
            </div>
          </div>
        </div>

        {(setting.about_title || setting.about_content || setting.about_image) && (
          <section style={{ background: 'linear-gradient(180deg,#fff 0%,#fafafa 100%)', padding: '60px 20px', margin: '40px 0 20px' }}>
            <div style={{ maxWidth: 1200, margin: '0 auto' }}>
              <div className="row align-items-center g-5">
                {setting.about_image && (
                  <div className="col-lg-6">
                    <div style={{ position: 'relative', borderRadius: 16, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.12)' }}>
                      <img src={setting.about_image} alt="" style={{ width: '100%', height: 'auto', display: 'block' }} />
                      <div style={{ position: 'absolute', top: -14, left: -14, right: 30, bottom: 30, border: '3px solid #dc3545', borderRadius: 16, zIndex: -1 }}></div>
                    </div>
                  </div>
                )}
                <div className={setting.about_image ? 'col-lg-6' : 'col-12'}>
                  <div style={{ display: 'inline-block', fontSize: 13, fontWeight: 700, color: '#dc3545', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12, paddingBottom: 6, borderBottom: '2px solid #dc3545' }}>
                    <i className="fas fa-heart"></i> ABOUT US
                  </div>
                  {setting.about_title && (
                    <h2 style={{ fontSize: 36, fontWeight: 900, color: '#222', lineHeight: 1.25, marginBottom: 14 }}>{setting.about_title}</h2>
                  )}
                  {setting.about_subtitle && (
                    <div style={{ fontSize: 17, color: '#666', marginBottom: 20, lineHeight: 1.6 }}>{setting.about_subtitle}</div>
                  )}
                  {setting.about_content && (
                    <div style={{ fontSize: 15, color: '#444', lineHeight: 1.8 }} dangerouslySetInnerHTML={{ __html: setting.about_content }}></div>
                  )}
                  <a href="/aboutUs" className="btn btn-danger mt-4" style={{ padding: '10px 28px', borderRadius: 30, fontWeight: 700 }}>
                    อ่านเพิ่มเติม <i className="fas fa-arrow-right" style={{ marginLeft: 6 }}></i>
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}

        <div className="container_home mt-5 mb-5">

          <div className="home-package row m-0">
            <div className="tourTitle mb-2">
              <h1><img src={moment} alt="moment" width={40} />&nbsp;&nbsp;&nbsp;ภาพประทับใจ </h1>
            </div>
            <div className="col-md-12 col-sm-12 card-contennar">
              <div className="swiper-container-initialized swiper-container-horizontal">
                {moments.length === 0 ? (
                  <div className="text-center py-4" style={{ color: '#bbb' }}>ยังไม่มีภาพประทับใจ</div>
                ) : (
                  <Swiper
                    spaceBetween={10}
                    slidesPerView={this.state.windowWidth < 700 ? 2 : this.state.windowWidth < 1000 ? 3 : this.state.windowWidth < 1400 ? 4 : 5}
                    loop={moments.length > 5}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                  >
                    {moments.map((m, i) => (
                      <SwiperSlide key={m.id}>
                        <div onClick={() => openMoment(i)} style={{ cursor: 'pointer', overflow: 'hidden', borderRadius: 6, position: 'relative', paddingBottom: '100%', background: '#f5f5f5' }}>
                          <img src={m.image} alt={m.caption || ''}
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }}
                            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
                            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
                          {m.caption && (
                            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '20px 8px 6px', background: 'linear-gradient(180deg, transparent, rgba(0,0,0,0.75))', color: '#fff', fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {m.caption}
                            </div>
                          )}
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </div>
            </div>

            {momentViewerIndex >= 0 && moments[momentViewerIndex] && (
              <div onClick={closeMoment} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000001, flexDirection: 'column', padding: 20 }}>
                <button onClick={(e) => { e.stopPropagation(); closeMoment(); }} style={{ position: 'absolute', top: 20, right: 24, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', width: 44, height: 44, borderRadius: '50%', fontSize: 22, cursor: 'pointer' }}>×</button>
                {moments.length > 1 && (
                  <>
                    <button onClick={(e) => { e.stopPropagation(); prevMoment(); }} style={{ position: 'absolute', left: 24, top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', width: 52, height: 52, borderRadius: '50%', fontSize: 24, cursor: 'pointer' }}>‹</button>
                    <button onClick={(e) => { e.stopPropagation(); nextMoment(); }} style={{ position: 'absolute', right: 24, top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', width: 52, height: 52, borderRadius: '50%', fontSize: 24, cursor: 'pointer' }}>›</button>
                  </>
                )}
                <img onClick={(e) => e.stopPropagation()} src={moments[momentViewerIndex].image} alt="" style={{ maxWidth: '95%', maxHeight: '85vh', objectFit: 'contain', boxShadow: '0 10px 40px rgba(0,0,0,0.5)' }} />
                {moments[momentViewerIndex].caption && (
                  <div style={{ color: '#fff', fontSize: 16, marginTop: 16, fontWeight: 500, textAlign: 'center' }}>{moments[momentViewerIndex].caption}</div>
                )}
                <div style={{ color: '#bbb', fontSize: 12, marginTop: 8 }}>{momentViewerIndex + 1} / {moments.length}</div>
              </div>
            )}
          </div>

        </div>
      </div>
    );
  }
}
